import { Box, Typography } from "@mui/material";
import { FC, PropsWithChildren } from "react";

import { PropsWithClasses } from "web/types/Common";

interface ISubscriptionSummaryProps {
  name: string;
}

const SubscriptionGroupSummaryMUI: FC<
  PropsWithChildren<PropsWithClasses<ISubscriptionSummaryProps>>
> = ({ children, name }) => {
  return (
    <Box
      sx={{
        borderRadius: 3,
        border: "1px solid #EEE",
        mb: 2,
      }}
    >
      <Typography variant="h6" mx={3} my={2}>
        {name}
      </Typography>
      {children}
    </Box>
  );
};

export default SubscriptionGroupSummaryMUI;
